import actions from './actions';

const {
  ADD_COUNTRY_BEGIN,
  ADD_COUNTRY_SUCCESS,
  ADD_COUNTRY_ERR,

  GET_COUNTRIES_BEGIN,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_ERR,

  UPDATE_COUNTRY_BEGIN,
  UPDATE_COUNTRY_SUCCESS,
  UPDATE_COUNTRY_ERR,

  DELETE_COUNTRY_BEGIN,
  DELETE_COUNTRY_SUCCESS,
  DELETE_COUNTRY_ERR,
} = actions;

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const countryReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ADD_COUNTRY_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ADD_COUNTRY_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };

    case ADD_COUNTRY_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case GET_COUNTRIES_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case GET_COUNTRIES_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case DELETE_COUNTRY_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DELETE_COUNTRY_SUCCESS:
      return {
        ...state,
        error: false,
        data,
        loading: false,
      };

    case DELETE_COUNTRY_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case UPDATE_COUNTRY_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_COUNTRY_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };

    case UPDATE_COUNTRY_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { countryReducer };
